import type { IconProps } from './types';

const HeroScoreIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 20, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...other}
      ref={ref}
    >
      <path
        d="M10 1.66666V3.75M10 1.66666C5.39765 1.66666 1.66669 5.39762 1.66669 10M10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 10M10 16.25V18.3333M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10M10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 10M3.75002 10H1.66669M18.3334 10H16.25M15.8987 15.8987L14.4206 14.4206M4.10138 15.8987L5.58098 14.4191M4.10138 4.16666L5.54842 5.61371M15.8987 4.16666L11.2499 8.75M11.6667 10C11.6667 10.9205 10.9205 11.6667 10 11.6667C9.07955 11.6667 8.33335 10.9205 8.33335 10C8.33335 9.07952 9.07955 8.33333 10 8.33333C10.9205 8.33333 11.6667 9.07952 11.6667 10Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { HeroScoreIcon };
